// extracted by mini-css-extract-plugin
export default {"root":"WhiteLabel_root__KHKCm","image-row":"WhiteLabel_image-row__YsSyW","image-babysam":"WhiteLabel_image-babysam__YKrRY","image-topdanmark":"WhiteLabel_image-topdanmark__pENUi"};